export default __webpack_public_path__ + "static/media/affiliate-cooperate.b66045b0.svg";